/**
 * « Ma passkey est rangee ailleurs » : l'utilisateur a cree la passkey d'un site dans une cle de securite ou le
 * trousseau de son systeme, pas dans Klavox. La Sante du coffre cesse alors de lui proposer d'en creer une pour
 * cette entree -- sans ce drapeau, la recommandation ne s'eteindrait jamais (1Password Watchtower permet de meme
 * d'ecarter « Passkeys available » entree par entree).
 *
 * Le drapeau vit DANS les secrets chiffres (`secrets.passkeyElsewhere === true`), comme `healthExcluded` : le
 * serveur ne sait pas quels comptes ont une passkey. Module pur, zero E/S.
 */
import type { EntrySecrets } from '@klavox/crypto-core';

/** La passkey de cette entree est-elle declaree rangee ailleurs ? Seul `true` compte (valeur importee mal formee = non). */
export function hasPasskeyElsewhere(secrets: EntrySecrets): boolean {
  return secrets['passkeyElsewhere'] === true;
}

/** Secrets avec (ou sans) le drapeau ; rien d'autre ne change. Seul `true` est ecrit, l'absence vaut « non ». */
export function withPasskeyElsewhere(secrets: EntrySecrets, elsewhere: boolean): EntrySecrets {
  const { passkeyElsewhere: _elsewhere, ...rest } = secrets;
  return elsewhere ? { ...rest, passkeyElsewhere: true } : rest;
}
